<template>
  <div id="main-box">
    <div class="page-content" :class="{bottom:list.length > 0}">
      <div class="table-box layui-body" style="left:0;">
        <div class="xblock layui-form">
          <div class="layui-input-inline xblock-row">
            <input type="text" name="username" placeholder="编号查询" v-on:keydown.13="get_sotck_list(true)" v-model="variation_id"
              autocomplete="off" class="layui-input" />
          </div>
          <div class="layui-input-inline xblock-row">
            <input type="text" name="username" placeholder="SKU查询" v-on:keydown.13="get_sotck_list(true)" v-model="sku_parent"
              autocomplete="off" class="layui-input" />
          </div>
          <div class="layui-input-inline xblock-row">
            <button class="layui-btn" style="height: 35px;" v-on:click="get_sotck_list(true)"><i
                class="fa fa-search"></i></button>
          </div>
          <span class="x-right xblock-row" v-text="'　共有数据：'+count+ '条'"></span>
          <div class="clear-both"></div>
        </div>
        
        <div class="table-box-list">
          <table class="layui-table layui-table-margin">
            <thead>
              <tr>
                <th style="width: 80px;">图片</th>
                <th>仓库</th>
                <th>站点</th>
                <th>店铺</th>
                <th>编号</th>
                <th>SKU</th>
                <th>规格</th>
                <th>名称</th>
                <th>库存</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody v-viewer>
              <tr class="order_box" v-for="(item,index) in list" v-bind:key="index">
                <td>
                  <div class="table_img col-img" :style="{'background-image': 'url('+item.image+')'}">
                    <img class="viewerimg" :src="item.image">
                  </div>
                </td>
                <td>
                  <div style="width: 45px;">
                    <i v-for="val in warehouseList" v-if="item.warehouse == val.id" v-text="val.name"></i>
                  </div>
                </td>
                <td v-text="item.customize_field.country"></td>
                <td v-text="item.customize_field.name"></td>
                <td>
                  <i v-if="item.variation_id != 0" v-text="item.variation_id"></i>
                  <i v-else>-</i>
                </td>
                <td v-text="item.sku_parent"></td>
                <td v-text="item.sku_name"></td>
                <td style="min-width: 150px;max-width:400px;word-break:break-all;">
                  <i v-text="item.name"></i>
                </td>
                <td>
                  <i class="redColor" v-if="item.stock > 0" v-text="item.stock"></i>
                  <i class="blueColor" v-else v-text="item.stock"></i>
                </td>
                <td class="btn-arr" style="width: 170px;">
                  <button class="layui-btn" v-on:click="StockDetail(item.variation_id)">详情</button>
                  <button class="layui-btn layui-btn-danger" v-on:click="DeleteItme(item.variation_id,item.items_id)">删除</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- transition -->
        <K-Transition :isLoding="isLoding" v-if="isLoding || list.length < 1" style="margin-top: 16px;"></K-Transition>

      </div>

      <!-- 分页 -->
      <div class="page-box"><div id="pagebox" class="pagebox"></div></div>

      <!-- loading -->
      <K-Loading v-if="loading"></K-Loading>

      <!-- toast -->
      <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

      <!-- 确认框 -->
      <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

    </div>
  </div>
</template>

<script>
  var self, form, layer, laypage;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  import Confirm from '@/components/common/Confirm.vue'
  export default {
    name: 'ConsumptionRecord',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
      'K-Confirm': Confirm,
    },
    data() {
      return {
        role:null,
        isLoding: false,
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        Confirm: {
          state: false,
          txt: null
        },
        page: 1,
        count: 0,
        total: 0,
        page_num: 20,
        status_id: 0,
        list: [],
        shop_list:[],
        varid:null,
        items_id:null,
        variation_id:null,
        sku_parent:null,
        uid:null,
        warehouseList:warehouseList
      }
    },
    mounted() {
      self = this;
      if(localStorage.getItem("ExShopee_Role") == 10){
        self.uid = 6;
      }else{
        self.uid = localStorage.getItem("ExShopee_id");
      }

      layui.use(['form', 'layer', 'laypage'], function() {
        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;
        form.render('select');
        self.get_sotck_list();
      });
    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      get_sotck_list() {
        self.isLoding = true;
        let param = new URLSearchParams()
        param.append('num', self.page_num)
        if(self.variation_id){
          param.append('variation_id', self.variation_id)
        }
        if(self.sku_parent){
          param.append('sku_parent', self.sku_parent)
        }
        param.append('uid', self.uid)
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/user_items_stock/?page=" + self.page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.isLoding = false;

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            if (datas.page) {
              var list = datas.list;
              for (let item in list) {
                if (list[item].customize_field) {
                  list[item].customize_field = JSON.parse(list[item].customize_field);
                }
              }
              self.list = list;
              self.total = datas.total;
              self.count = datas.page.count;
              self.ShowPage(self, laypage, "get_sotck_list"); //分页
              $('.pagebox').show();
            } else {
              self.list = [];
              self.count = 0; //页数
              $('.pagebox').hide();
            }
          });

        }).catch(function(error) {
          self.isLoding = false;
          console.log(error);
        })
      },
      StockDetail (variation_id) {
        localStorage.setItem("ExShopee_NavSubIx", 1);
        self.$router.push({
          path: "StockRecord" + '?id=' + variation_id
        })
      },
      DeleteItme(variation_id,items_id) {
        self.Confirm.txt = "是否确认删除？"
        self.Confirm.style = 1;
        self.Confirm.state = true;
        self.varid = variation_id;
        self.items_id = items_id;
      },
      ConfirmBackFun(data) {

        self.Confirm.state = data.state;
        if (data.state) {
          self.loading = true;
          self.Confirm.state = false;
          if(self.varid){
            var datas = {variation_id:self.varid}
          }else{
            var datas = {items_id:self.items_id}
          }
          $.ajax({
            url: self.GetServerUrl() + "/user_items_stock_delete/",
            type: 'post',
            data: datas,
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            },
            success: function(res) {
              self.loading = false;
              var json = JSON.parse(res);
              layer.msg(json.msg);
              if (json.code == 200) {
                self.get_sotck_list();
              }
            },
            error: function(error) {
              self.loading = false;
              layer.msg(error);
            }
          })
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }
  .country_select {
    width: 150px;
  }
</style>



// WEBPACK FOOTER //
// src/components/logistics/Stock.vue